import axios from 'axios'

const factura = {

    getCedis: () => axios(`cedis/factura/get-cedis`),
    updateCedi: (id,texto) => axios.put(`cedis/${id}/factura`,{texto}),
}
export default factura
